import { Validators } from "@angular/forms"
import { GridOption, GridSettingsType, LayerType, sharedForms } from "../layer.model"
import { FormType, GridLinesProperties, Properties } from "../properties.model"

const gridTypes: GridOption[] = [
  { label: 'Grid', value: GridSettingsType.Grid },
  { label: 'Vertical', value: GridSettingsType.Vertical },
  { label: 'Horizontal', value: GridSettingsType.Horizontal },
  // { label: 'Hex', value: GridSettingsType.Hex },
]

export const gridLinesForm: Properties = {
  propertyType: LayerType.GridLines,
  label: 'Grid Lines Layer',
  info: "Lines may appear slightly blurry, transparent, or completely dark at high densities. Export your render for a true preview of how the lines will look.",
  forms:
    sharedForms.concat([
    {
      id: GridLinesProperties.GridLinesStyle,
      label: 'Line Type',
      type: FormType.Select,
      placeholder: 'Grid Styles',
      defaultValue: [{viewValue: "Grid", value: GridSettingsType.Grid}],
      validators: [Validators.required, Validators.minLength(1)],
      options: gridTypes
    },
    {
      id: GridLinesProperties.GridLinesColor,
      label: 'Color',
      type: FormType.Color,
      placeholder: "#Hex Color",
      defaultValue: '#000000',
      validators: [Validators.required, Validators.min(1)],
    },
    {
      id: GridLinesProperties.GridLinesOpacity,
      label: 'Line Opacity',
      type: FormType.SliderNumber,
      defaultValue: 1,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
    {
      id: GridLinesProperties.GridLinesDensity,
      label: 'Density',
      type: FormType.SliderNumber,
      hint: "How many lines appear on the map.",
      defaultValue: .5,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
    {
      id: GridLinesProperties.GridLinesOffsetX,
      label: 'Offset X',
      type: FormType.SliderNumber,
      defaultValue: 0,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
    {
      id: GridLinesProperties.GridLinesOffsetY,
      label: 'Offset Y',
      type: FormType.SliderNumber,
      defaultValue: 0,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
  ]),
  changeHandler: () => {}
}

